import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import I18n from "lib/i18n/i18n";
import SideBar from "./sideBar";
import NoMatch from "../../components/noMatch";
import WorthyApiErrors from "lib/api/worthyApiErrors";
import WorthyApi from "lib/api/worthyApi";
import { updateCustomExperiments } from "actions/experiments";
import { isMobile } from "helpers/ApplicationHelper";
import LogosFooter from "./logosFooter";
import Charts from "./charts";
import UserActions from "lib/userActions";

class Trends extends Component {
    constructor(props) {
        super(props);

        this.state = {
            trends: "",
            estimations: "",
            isTop: false,
            showProperties: false,
            scrollPosition: 0,
        };

        this.handleScroll = this.handleScroll.bind(this);
        this.sellButtonClick = this.sellButtonClick.bind(this);

        WorthyApi.getItemTrendsByPublicID(this.props.params.itemId)
            .then((res) => {
                this.setState({
                    trends: res.data,
                });
            })
            .catch((error) => {
                this.setState({ trends: error });
            });
    }

    componentDidMount() {
        UserActions.trendsPage(
            "Trends page presented",
            this.props.params.itemId
        );
        if (isMobile) {
            window.addEventListener("scroll", this.handleScroll);
        }
    }

    handleScroll() {
        let scrollPosition = window.pageYOffset;
        let isTop = scrollPosition > 140;
        if (isTop !== this.state.isTop) {
            this.setState({ isTop });
        }
    }

    sellButtonClick() {
        this.props.onComplete();
        UserActions.trendsPage(
            "Continue button clicked",
            this.props.params.itemId
        );
    }

    render() {
        let trends = this.state.trends;

        if (!trends) {
            return <noscript></noscript>;
        }
        let error = trends instanceof WorthyApiErrors;

        if (error && trends.hasError(404)) {
            return <NoMatch />;
        }

        let itemDescription =
            I18n.getString("itemPage::trends::your") +
            " " +
            (trends.desc || "");
        let relevantStates = I18n.getString("itemPage::trends::relevantStates");
        let isRing = trends.item_type_name === "ring" && trends.estimation;
        let missing_trends_values =
            !error &&
            Object.values(trends.trends).filter((x) => {
                return !x.length;
            }).length; // maybe to check Object.values(trends).flat() < 12*3

        if (
            (error && trends.hasError(500)) ||
            relevantStates.indexOf(this.state.trends.workflow_state) == -1 ||
            !isRing ||
            !trends.main_stone ||
            missing_trends_values
        ) {
            this.props.onComplete();
            return <noscript></noscript>;
        }

        return (
            <div id="trends">
                <div className="wrapper">
                    <div id="title-section">
                        <div className="title">
                            {I18n.getString("itemPage::trends::title")}
                        </div>
                        <div className="sub-title">
                            {I18n.getString("itemPage::trends::subTitle")}
                        </div>
                    </div>
                    <div className="container">
                        <SideBar
                            trends={trends}
                            itemDescription={itemDescription}
                            onClick={this.sellButtonClick}
                        />
                        <Charts
                            trends={trends}
                            itemId={this.props.params.itemId}
                        />
                    </div>
                    <div className="footer">
                        <LogosFooter />
                    </div>
                </div>
                {isMobile() ? (
                    <div
                        className={
                            this.state.isTop
                                ? "mobile-footer sticky"
                                : "mobile-footer"
                        }
                    >
                        <div className="item-props-desc">{itemDescription}</div>
                        <button
                            id="second"
                            className="btn btn-orange sell-now"
                            onClick={this.sellButtonClick}
                        >
                            {I18n.getString("itemPage::trends::buttonSellNow")}
                        </button>
                    </div>
                ) : null}
            </div>
        );
    }
}

const mapStateToProps = ({ Session }) => {
    return { Session };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ updateCustomExperiments }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Trends);
// export default Trends;
